"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cores = void 0;
var CoresIdentidadeMU_1 = __importDefault(require("./CoresIdentidadeMU"));
var GradacaoNeutros_1 = __importDefault(require("./GradacaoNeutros "));
var GradacaoPrimaria_1 = __importDefault(require("./GradacaoPrimaria"));
var MensagensDoSistema_1 = __importDefault(require("./MensagensDoSistema"));
var TextoDestaque_1 = __importDefault(require("./TextoDestaque"));
var TextoPadrao_1 = __importDefault(require("./TextoPadrao"));
var Cores = /** @class */ (function () {
    function Cores() {
    }
    Cores.CoresIdentidadeMU = CoresIdentidadeMU_1.default;
    Cores.GradacaoNeutros = GradacaoNeutros_1.default;
    Cores.GradacaoPrimaria = GradacaoPrimaria_1.default;
    Cores.TextoPadrao = TextoPadrao_1.default;
    Cores.TextoDestaque = TextoDestaque_1.default;
    Cores.MensagensDoSistema = MensagensDoSistema_1.default;
    return Cores;
}());
exports.Cores = Cores;
